import { render, staticRenderFns } from "./virtualOrder.vue?vue&type=template&id=346da5ea&"
import script from "./virtualOrder.vue?vue&type=script&lang=js&"
export * from "./virtualOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports